// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import { getModifiedBy } from '../../../utils/cells';

export default class AccountingGatewayTransactionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accountingGatewayTransactions';
        this.Server = this.props.context.getState().server.accountingGatewayTransactions;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['gatewayAccount.name', 'systemAccount.name'];
        this.showDatePicker = false;


        const defaultHead = [
            {
                id: 'gatewayAccountId',
                label: 'gatewayAccount',
                alignRight: false,
                cell: 'Select',
                from: 'accountingGatewayAccounts',
                show: 'name',
                object: 'gatewayAccount',
                displayGrid: true
            },
            {
                id: 'systemAccountId',
                label: 'systemAccount',
                alignRight: false,
                cell: 'Select',
                from: 'accountingSystemAccounts',
                show: 'name',
                object: 'systemAccount',
                displayGrid: true
            },
            {
                id: 'gatewayAmount',
                label: 'gatewayAmount',
                alignRight: false,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'systemAmount',
                label: 'systemAmount',
                alignRight: false,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'direction',
                label: 'direction',
                alignRight: false,
                cell: 'Items',
                items: ['deposit', 'withdrawal'],
                displayGrid: true
            },
            {
                id: 'description',
                label: 'description',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'paymentDate',
                label: 'paymentDate',
                alignRight: false,
                cell: 'Date',
                displayGrid: true,
                default: 'today'
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true,
                extraRender: (value, row) => getModifiedBy(row)
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
